import { render, staticRenderFns } from "./JudgmentDiligenceReview.vue?vue&type=template&id=0a293785&"
import script from "./JudgmentDiligenceReview.vue?vue&type=script&lang=js&"
export * from "./JudgmentDiligenceReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports